angular.module('dpw.components')
    /**
     * @ngdoc component
     * @name dpwAlert
     * @restrict E
     * @description
     * Display an alert.
     * @param {string} level - Could be one of success | info | warning | danger
     * @param {string} [storage] - The key that used for LocalStorage.
     * @param {boolean} [dismissible] - Display a close button to dismiss the alert.
     * @param {function} [onDismiss] - Function to call when alert is dismissed.
     * @param {boolean} [display] - to or not to display alert.
     * @example
     * <dpw-alert level="info" dismissible="true" storage="key"></dpw-alert>
     */
    .component('dpwAlert', {
        templateUrl: 'dpw-alert.html',
        transclude: true,
        bindings: {
            level: '@',
            storage: '@?',
            dismissible: '<?',
            display: '<?',
            onDismiss: '&?',
            extraClass: '@?'
        },
        controller: ['dpwStorage', function (dpwStorage) {
            var storageKey = this.storage;
            var HAS_LOCAL_STATE = angular.isString(storageKey);
            var LOCAL_DISMISS_VALUE = 'false';

            this.$onInit = function () {
                this.couldDisplay = this.display !== false && !isLocalDismissed();
                this.extraClass = this.extraClass || '';
            };
            this.$onChanges = function (changes) {
                if (changes.display) {
                    this.couldDisplay = !isLocalDismissed() && changes.display.currentValue;
                }
            };
            this.dismiss = function () {
                this.couldDisplay = false;
                if (HAS_LOCAL_STATE) {
                    dpwStorage.setItem(storageKey, LOCAL_DISMISS_VALUE);
                }
                if ( angular.isFunction(this.onDismiss) ) {
                    this.onDismiss();
                }
            };

            function isLocalDismissed() {
                return HAS_LOCAL_STATE &&
                    dpwStorage.getItem(storageKey) === LOCAL_DISMISS_VALUE;
            }
        }]
    });